<template lang="">
 <div class="container">
   <div class="row">
    <div v-if="paises.length <= 0">
      <p class="h1 my-5">No se encontraron paises.</p>
    </div>
    <div class="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center" 
      v-for="(pais, index) in paises" 
      :key="index"
    >
      <Card
        :pais="pais"
      />
    </div>
  </div>
  <hr>
 </div>
</template>
<script>
import Card from './Card.vue'
import { useStore } from 'vuex'
import { computed, onMounted } from '@vue/runtime-core'
export default {
  components: {
    Card
  },
  setup() {
    const store = useStore()
    onMounted(async() => {
      await store.dispatch('getPaises')
      await store.dispatch('filterByRegion')
    })
    let paises = computed(() => {
      return paises = store.getters.topPaises
    })
    return { paises }
  },
}
</script>